export enum PrintPaperSPUnitEnum {
  prescription = "prescription", //Toa
  Box = "Box", // Hộp
}
